import { useLazyFetch, useLazyPost } from "../utils/apiclient";
import { qaosUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useGetAutomationRuns = (deploymentStage, tenantUrl) => {
  return useLazyFetch(
    `${qaosUrl}/tessell/${deploymentStage}/tenants/${tenantUrl}/automation-runs`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useTriggerAutomationRun = (deploymentStage, tenantUrl) => {
  return useLazyPost(
    `${qaosUrl}/tessell/${deploymentStage}/tenants/${tenantUrl}/automation-runs`,
    {
      headers: { ...getHeaders(), Action: "TRIGGER" },
      method: "POST",
    }
  );
};
